var React = require('react');

function Documents (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 0.878906H2C1.175 0.878906 0.5075 1.55391 0.5075 2.37891L0.5 14.3789C0.5 15.2039 1.1675 15.8789 1.9925 15.8789H11C11.825 15.8789 12.5 15.2039 12.5 14.3789V5.37891L8 0.878906ZM11 14.3789H2V2.37891H7.25V6.12891H11V14.3789Z","fill":"currentColor"}));
}

Documents.defaultProps = {"width":"13","height":"18","viewBox":"0 0 13 18","fill":"none"};

module.exports = Documents;

Documents.default = Documents;
